import { isEmpty } from 'lodash';
import { Recurrence } from '~/lib/util/calendar.util';

export const isScheduledItemRecurring = (frequency: string): boolean =>
  !isEmpty(frequency) &&
  Recurrence.DOES_NOT_REPEAT.toLowerCase() !== frequency.toLowerCase();
